import React from "react";
import ExportPdfConsentimiento from "../Visitas/Consentimiento/consentimiento_pdf";
import ExportActaInicioPDF from "../Visitas/ActaInicio/acta_inicio_pdf";
import ExportAnalisisCapacidadesPDF from "../Visitas/AnalisisCapacidades/exportable/analisis_capacidades_pdf";
import ExportDiagnosticoPDF from "../Visitas/Diagnostico/exportable/diagnostico_pdf";
import ExportAutorizacionImagenPDF from "../Visitas/Autorizacion_imagen/exportable.jsx/autorizacion_imagen_pdf";
import ExportMedicionCapacidadSalidaPDF from "../Visitas/medicionCapacidadesSalida/exportable/medicion_capacidades_salida_pdf";

const ComponentEvaluator = ({ data, tipo_visita, actionVolver }) => {
  const renderComponent = () => {
    if (tipo_visita === 1) {
      return (
        <ExportPdfConsentimiento
          formData={data}
          actionVolver={actionVolver}
        ></ExportPdfConsentimiento>
      );
    } else if (tipo_visita === 2) {
      return (
        <ExportDiagnosticoPDF
          formData={data}
          actionVolver={actionVolver}
        ></ExportDiagnosticoPDF>
      );
    } else if (tipo_visita === 3) {
      return (
        <ExportAnalisisCapacidadesPDF
          formData={data}
          actionVolver={actionVolver}
        ></ExportAnalisisCapacidadesPDF>
      );
    } else if (tipo_visita === 4) {
      return (
        <ExportAutorizacionImagenPDF
          formData={data}
          actionVolver={actionVolver}
        ></ExportAutorizacionImagenPDF>
      );
    } else if (tipo_visita === 5) {
      return (
        <ExportActaInicioPDF
          formData={data}
          actionVolver={actionVolver}
        ></ExportActaInicioPDF>
      );
    } else {
      return (
        <ExportMedicionCapacidadSalidaPDF
          formData={data}
          actionVolver={actionVolver}
        ></ExportMedicionCapacidadSalidaPDF>
      );
    }
  };

  return <div>{renderComponent()}</div>;
};

// Ejemplo de uso
const Renderizar = ({ data, tipo_visita, actionVolver }) => {
  return (
    <div style={{ padding: "20px" }}>
      <ComponentEvaluator
        data={data}
        tipo_visita={tipo_visita}
        actionVolver={actionVolver}
      />
    </div>
  );
};

export default Renderizar;
